<template>
  <button
    class="tla-btn tla-btn--link"
    @click="submitGoToStep()"
    v-if="showButton"
    type="button"
    :name="goToStepButtonId"
    :id="goToStepButtonId"
  >
    {{ buttonText }}
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GoToStepButtonComponent extends Vue {
  @Prop({ default: 'Go To Step' })
  public buttonText!: string;

  @Prop({ default: 1 })
  public stepNumber!: number;

  public goToStepButtonId: string = '';

  public get interactedSteps(): number {
    return this.$store.getters['enquiryModule/interactedSteps'];
  }

  public get showButton(): boolean {
    return this.stepNumber <= this.interactedSteps;
  }

  public submitGoToStep() {
    this.$store.dispatch(
      'enquiryModule/submitNextStep',
      this.stepNumber
    );
  }

  public created() {
    this.goToStepButtonId = `go-to-step-button-${this.stepNumber}`;
  }
}
</script>
